// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const passwordResetInPasswordMax = 256;

export const PasswordResetIn = zod.object({
  "password": zod.string().min(1).max(passwordResetInPasswordMax)
});

export type PasswordResetIn = zod.input<typeof PasswordResetIn>;
export type PasswordResetInOutput = zod.output<typeof PasswordResetIn>;
